import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '@/utils/api';

/**
 * Toggle like on a comment
 */
export const toggleCommentLike = createAsyncThunk(
  'comment/toggleLike',
  async (commentId: string, { rejectWithValue }) => {
    try {
      const response = await api.post(`/comments/${commentId}/like`);
      return {
        commentId,
        ...response.data,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to like comment');
    }
  }
);

/**
 * Toggle dislike on a comment
 */
export const toggleCommentDislike = createAsyncThunk(
  'comment/toggleDislike',
  async (commentId: string, { rejectWithValue }) => {
    try {
      const response = await api.post(`/comments/${commentId}/dislike`);
      return {
        commentId,
        ...response.data,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to dislike comment');
    }
  }
);
